import React from 'react';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import slotimg from "../../images/free.png";
import './refund.css';


const RefundList = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);
  const [ refundpopup,setrefundpopup ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  
  const [EmployeeD, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    e_name: "", 
    e_email: null, 
    e_password: null,
    e_phone: null,
    e_role: "",
    profile: null,
    shops: [],
    user_id: localStorage.getItem("userId"),
});
const [remarks, setRemarks] = useState('');
const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});

console.log(formData)

//change the role
  const handleCodeSelectChange = (selectedItem) => {
    console.log("selectedItem",selectedItem)
    const role = selectedItem.value
    setFormData({ ...formData, e_role: role });
  };

  
//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};
const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};
    useEffect(() => {
        fetchTables();
        fetchShops();
      }, []);


      const fetchTables = async (id) => {
        const userId = localStorage.getItem('userId');
        setLoading(true);
        console.log(id)
        const shopId = id === undefined ? 0 : id;
        try {
           const shop = localStorage.getItem('shopId')
           const response = await axios.get(`${var_api}/api/employees/get-emplyees/${userId}/${shopId}`);
           setLoading(false);
           console.log("response",response)
          const user =response.data.results;
          setTables(user);
          
        } catch (error) {
          setLoading(false);
          console.log(error);
          setTables([])
        }
      };
      

      const fetchShops = async () => {
        try {
           const shop = localStorage.getItem('userId')
           const response = await axios.get(`${var_api}/api/shop/data/${shop}`);
           console.log("response",response)
          const user =response.data;
          setShops(user);
          setFormData(prevState => ({
            ...prevState,
            shops: user.map(shop => ({ shop_id: shop.id, shop_name: shop.shop_name, is_active: 0 }))
          }));
        } catch (error) {
          console.log(error);
        }
      };

      const shopCodeOptions = [
        { value: 0, label: 'All' },
        ...shops.map(shop => ({
          value: shop.id,
          label: shop.shop_name
        }))
      ];
      
      

     //search the transaction data
     const filteredSuppliers = tables && tables.filter((order) => {
      const searchLower = searchQuery.toLowerCase();
      return (
        (order.e_name && order.e_name.toString().toLowerCase().includes(searchLower)) ||
        (order.e_email && order.e_email.toString().toLowerCase().includes(searchLower))  ||
        (order.e_phone && order.e_phone.toString().toLowerCase().includes(searchLower))  ||
        (order.e_role && order.e_role.toString().toLowerCase().includes(searchLower)) 
      );
    });

//handle image change
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log("files",file);
        setFormData({ ...formData, profile: file });
      };

//handle text field change
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value
  });
};


 // Function to handle checkbox change
 const handleCheckboxChange = (index) => {
  const updatedShops = [...formData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };

  setFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

      //post the form data
    const Submit = async (e) => {
      e.preventDefault();
      setPostLoading(true);

      try {

        const camelCaseEName = capitalize(formData.e_name);

        const formDataToSend = new FormData();
        // Append all form fields to the FormData object
        formDataToSend.append('e_name', camelCaseEName);
        formDataToSend.append('e_email', formData.e_email);
        formDataToSend.append('e_password', formData.e_password);
        formDataToSend.append('e_phone', formData.e_phone);
        formDataToSend.append('e_role', formData.e_role);
        formDataToSend.append('profile', formData.profile);
        formDataToSend.append('user_id', formData.user_id);
    
        // Append shop data (if any)
        formData.shops.forEach((shop, index) => {
          formDataToSend.append(`shops[${index}][shop_name]`, shop.shop_name);
          formDataToSend.append(`shops[${index}][shop_id]`, shop.shop_id);
          formDataToSend.append(`shops[${index}][is_active]`, shop.is_active);
        });
        

        const response = await axios.post(`${var_api}/api/employees/post`, formDataToSend, {
            headers: {
                'Content-Type': 'multipart/form-data' // Set content type to multipart/form-data
            }
        });
        const result = response.data;
        console.log("rrrr",result);
        if(result.message === "Employee created successfully"){
          fetchShops();
          setCreate(false);
          fetchTables();
          setPostLoading(false)
          Swal.fire({
            icon:"success",
            text:'Employee Created Successfully',
            confirmButtonColor:"#007500"
          })

          setFormData({...formData,
            e_name: "", 
            e_email: " ", 
            e_password: "",
            e_phone: "",
            e_role: "",
            profile: " "
          })
          

        }
        // Handle successful response (e.g., show a success message to the user)
      } catch (error) {
        // Handle request failure
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      setPostLoading(false)

      console.error('Server responded with error status:', error.response.status);
      if (error.response.data && error.response.data.message) {
        setPostLoading(false)
       
        Swal.fire({
          icon:"error",
          text: error.response.data.message,
          confirmButtonColor:"#007500"
        })
      } else {
        alert('An error occurred. Please try again later.');
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received from the server:', error.request);
      setPostLoading(false)
      alert('No response received from the server. Please try again later.');
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error occurred while setting up the request:', error.message);
      setPostLoading(false)
      alert('An error occurred. Please try again later.');
    }
        
      }
    };


    //reset the values
    const handleToReset = () => {
         // Reset the form fields individually
         setFormData({
          ...formData,
          e_name: " ", 
  e_email: "", 
  e_password:" ",
  e_phone:"",
  e_role:"",
  profile:null
      });
    }

    //Go to home page
    const handleButtonClick = () => {
      history.push('/AdminHome')
    }


    //get the value in search and set the setstate
    const handleSearchInput = (e) => {
      setSearchQuery(e.target.value)
      };


      

     //delete method for remove UOM
   const handleDeleteEmployeee = (id,e_name) => {
    setShow(true);
    setEmployeeD({id:id,employee_name: e_name})
    }


    //delete the employeee
    const handleDelete = () => {
      axios
      .delete(`${var_api}/api/employees/emp-delete/${EmployeeD.id}`)
      .then((response) => {
        if (response.status === 200) {
          fetchTables();
          setShow(false);
          Swal.fire("success"," Employee Removed Successfully!","success")
          // Perform any other actions you need on success
        } else if (response.status === 404) {
          console.log('Table not found');
          Swal.fire("error","Employee not found!","error")
        }
      })
      .catch((error) => {
        console.error('Error executing the request:', error);
        Swal.fire("error","Failed to Remove Employee!","error")
        // Handle the error as needed
      });
    }


    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
      console.log("data",data)
      setUpdateFormData({
          id:data.id,
          e_name: data.e_name, 
          e_email: data.e_email, 
          e_password: data.e_password,
          e_phone: data.e_phone,
          e_role: data.e_role,
          profile: data.e_profile,
          shops: data.shops
      })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
    }

    const handlerefundpopup = () =>{
        setrefundpopup(true);
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};


//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};

//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile: file });
};


 // Function to handle update checkbox change
 const handleUpdateCheckboxChange = (index) => {
  const updatedShops = [...updateformData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };
  console.log("upd",updatedShops);

  setUpdateFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


//update method for employee
//post method for updating the food
const handleUpdateSubmit = async (e) => {
  e.preventDefault();  
  console.log("updateformData",updateformData);
 
  
  const camelCaseEName = capitalize(updateformData.e_name);

  const formDataToSend = new FormData();
  formDataToSend.append('e_name', camelCaseEName);
  formDataToSend.append('e_email', updateformData.e_email);
  formDataToSend.append('e_password', updateformData.e_password);
  formDataToSend.append('e_phone', updateformData.e_phone);
  formDataToSend.append('e_role', updateformData.e_role);
  formDataToSend.append('profile', updateformData.profile); 

   // Append shop data (if any)
   updateformData.shops.forEach((shop, index) => {
    formDataToSend.append(`shops[${index}][shop_name]`, shop.shop_name);
    formDataToSend.append(`shops[${index}][shop_id]`, shop.shop_id);
    formDataToSend.append(`shops[${index}][is_active]`, shop.is_active);
  });
  

   try {
    const response = await fetch(`${var_api}/api/employees/emp-put/${updateformData.id}`, {
      method: 'PUT',
    body: formDataToSend,
  });
    if(response.status == 200){
      fetchTables();
      setIsEdit(false);
      Swal.fire({
        title: 'Success',
        text: 'Employee Updated Successfully.',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
      
      const data = await response.json();
      console.log('Registration successful!',data);
   
    }else {
      console.error('Failed to Update Food:', response.statusText);
      // Handle error, e.g., show an error message to the user
      Swal.fire({
        title: 'error',
        text: 'Failed to Update Food...Please Try Again!',
        icon: 'error',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    }
    
    // Handle success scenario as needed
  } catch (error) {
      console.error('Error:', error);
      // Handle error scenario as needed
    }
  };

  const data = [
    { id: 1, orderNo: '123', address: '123,ABC, trichy', orderType: 'Normal Order', slotType: 'Single slot', slot: 'Slot-1', date: '07-11-2024', customer: 'JP', phone: '9876543210', amount: '250', status: 'Pending' },
    { id: 2, orderNo: '123', address: '123,ABC, trichy', orderType: 'Credit Order', slotType: 'Multi Slot', slot: 'Slot-1', date: '07-11-2024', customer: 'Jesi', phone: '9876540000', amount: '350', status: 'Paid' },
    { id: 3, orderNo: '124', address: '456,DEF, madurai', orderType: 'Normal Order', slotType: 'Single slot', slot: 'Slot-2', date: '08-11-2024', customer: 'Vicky', phone: '9876541234', amount: '500', status: 'Pending' },
    { id: 4, orderNo: '125', address: '789,GHI, coimbatore', orderType: 'Credit Order', slotType: 'Multi Slot', slot: 'Slot-2', date: '09-11-2024', customer: 'Ravi', phone: '9876545678', amount: '300', status: 'Paid' },
    { id: 5, orderNo: '126', address: '321,JKL, chennai', orderType: 'Normal Order', slotType: 'Single slot', slot: 'Slot-3', date: '10-11-2024', customer: 'Priya', phone: '9876548765', amount: '450', status: 'Pending' },
    { id: 6, orderNo: '127', address: '654,MNO, tirunelveli', orderType: 'Credit Order', slotType: 'Multi Slot', slot: 'Slot-3', date: '11-11-2024', customer: 'Kumar', phone: '9876544321', amount: '550', status: 'Paid' },
    { id: 7, orderNo: '128', address: '987,PQR, salem', orderType: 'Normal Order', slotType: 'Single slot', slot: 'Slot-4', date: '12-11-2024', customer: 'Maya', phone: '9876541122', amount: '650', status: 'Pending' },
    { id: 8, orderNo: '129', address: '543,STU, erode', orderType: 'Credit Order', slotType: 'Multi Slot', slot: 'Slot-4', date: '13-11-2024', customer: 'Manoj', phone: '9876549988', amount: '700', status: 'Paid' },
    { id: 9, orderNo: '130', address: '111,VWX, vellore', orderType: 'Normal Order', slotType: 'Single slot', slot: 'Slot-5', date: '14-11-2024', customer: 'Suresh', phone: '9876542233', amount: '800', status: 'Pending' },
    { id: 10, orderNo: '131', address: '222,YZA, pondicherry', orderType: 'Credit Order', slotType: 'Multi Slot', slot: 'Slot-5', date: '15-11-2024', customer: 'Anjali', phone: '9876543344', amount: '900', status: 'Paid' },
  ];
  


    return(
      <>         <Layout>

        {/* <div className='whole' style={{backgroundColor:"white"}}> */}
            {/* <div class="split left">
                <div class="centered">
                    <h3 className='ushe'>EMPLOYEE MASTER</h3>
                    <div style={{marginLeft:"12px",padding:"12px"}}>

                    <form onSubmit={Submit}>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="text" class="form-control" id="floatingInput" placeholder="name" name='e_name' value={formData.e_name} onChange={handleInputChange}  style={{borderRadius:"15px",height:"50px"}} required/>
                            <label for="floatingInput">Employee Name</label>
                        </div>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com" name='e_email' value={formData.e_email} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required/>
                            <label for="floatingInput">Email Address</label>
                        </div>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="text" class="form-control" id="floatingInput" placeholder="password" name='e_password' value={formData.e_password} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required />
                            <label for="floatingInput">password</label>
                        </div>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="number" class="form-control" id="floatingInput" placeholder="phone" name='e_phone' value={formData.e_phone} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} required/>
                            <label for="floatingInput">Phone No</label>
                        </div>
                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto",zIndex:"2"}}>
                        <Select
                        options={ItemCodeOptions}
                        placeholder="Select Role"
                        onChange={handleCodeSelectChange}
                        isSearchable={true}
                        className="customSelect mb-3"
                        styles={{
                          // Styles for increasing width and height
                          control: (provided, state) => ({
                            ...provided,
                            width: '350px', // Adjust width as needed
                            minHeight: '50px', // Adjust height as needed
                            borderRadius: '15px'
                          }),
                        }}
                         />
                         </div>

                         <div class="card mb-3" style={{width: "22rem",margin:"auto",height:"10rem",borderRadius:"15px",border:"none",overflowX:"scroll",zIndex:"1"}}>
                          <div class="card-body">
                            <h5 class="card-title" style={{fontSize:"14px",color:"green"}}>Select Shop</h5>
                            {formData.shops.map((shop, index) => (
        <div className="form-check" key={index}>
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id={`flexCheckDefault_${index}`}
            onChange={() => handleCheckboxChange(index)}
            checked={shop.is_active === 1}
          />
          <label className="form-check-label" htmlFor={`flexCheckDefault_${index}`}>{shop.shop_name}</label>
        </div>
      ))}   
                           
                          </div>
                         </div>

                        <div class="form-floating mb-3" style={{width:"350px",margin:"auto"}}>
                            <input type="file" class="form-control" id="formFile" onChange={handleImageChange} name='profile'  style={{borderRadius:"15px",height:"50px"}} />
                        </div>
                        
                        <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{float:"right"}} disabled={postloading}>Create Employee</button>
        )}
        </div>       
            </form>
            
            <button className='btn btn-secondary' style={{float:"right",marginRight:"3px"}} onClick={handleToReset} >Reset</button> {' '}
                       
                        
                    </div>
                   
                </div>
            </div> */}

            <div class="splitrefund">
          
            <div style={{border:"none", padding:"15px", width:"100%", height:"630px",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"-15px"}}>    
    {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"18px",float:"right",borderRadius:"15px"}}>Create Blocked Slot</Button>{' '} */}
    
    <div>
  
   
     <div class="row">
       <div class="col">
        <h4 className='ushe'>REFUND</h4>
       </div>
       <div class="col">
       <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
       </div>
     </div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll', marginTop:"5px" }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"95%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Id</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Address</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Type</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Type</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Date</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Customer name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Mobile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Amount</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Refund</th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
  <tbody class="body-half-screen">
   {/* {filteredSuppliers && filteredSuppliers.length > 0 ? (
   filteredSuppliers && filteredSuppliers.map((data,index) =>( */}
{data.map((item, index) => (
        <tr key={item.id} style={{ padding: "4px" }}>
          <th scope="row" style={{ textTransform: "capitalize", textAlign: "left" }}>{index + 1}</th>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.orderNo}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.address}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left", color: item.orderType === 'Normal Order' ? 'blue' : 'orange', fontWeight: 'bold' }}>
            {item.orderType}
          </td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.slotType}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.slot}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.date}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.customer}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.phone}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.amount}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left", color: item.status === 'Pending' ? 'red' : 'green', fontWeight: 'bold' }}>
            {item.status}
          </td>
          <td>
            {item.status === 'Paid' ? (
              <div style={{ textTransform: "capitalize", textAlign: "left", display: "flex", gap: "2px" }}>
                <Button variant="dark" size="sm" style={{ padding: "2px 8px", fontSize: "17px" }} onClick={handlerefundpopup}>Go Link</Button>
              </div>
            ) : ( "-"
            )}
          </td>
        </tr>
      ))}
   {/* ))
   ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center", color:"red", fontWeight:"bold", borderColor:"black" }}>
        Slot Not Found
      </td>
    </tr>
   )} */}
 

   </tbody>
}
</table>

      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(6, 105, 16, 0.367)",padding:"22px"}}>
          {/* <Modal.Title>confirmation</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Blocked Slot 
          <span style={{color:"red",textTransform:"uppercase"}}> {EmployeeD.employee_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Blocked Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={handleUpdateSubmit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Select Date</label>
              <input type="date" class="form-control" placeholder="Enter Select Date" id="input1" value={updateformData.e_name}  name="e_name"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div className="col">
  <label
    htmlFor="slotSelect"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
    Select Slot
  </label>
  <select
    className="form-control"
    id="slotSelect"
    name="e_slot"
    value={updateformData.e_slot}
    onChange={handleInputUpdateChange}
    style={{ borderRadius: "12px" }}
    required
  >
    <option value="">Select a Slot</option>
    <option value="slot1">Slot 1</option>
    <option value="slot2">Slot 2</option>
    <option value="slot3">Slot 3</option>
    {/* Add more options as needed */}
  </select>
</div>

          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Enter Remarks{" "}</label>
              <input type="text" class="form-control" id="formFile"  name='profile' placeholder='Enter Remarks' style={{borderRadius:"12px"}} onChange={handleImageUpdateChange} />
            </div>
            <div class='col'></div>
          </div>
          {/* <div class="row">
            <div class="col">
          <div class="card mb-3" style={{width: "22rem",height:"10rem",borderRadius:"15px",border:"none",overflowX:"scroll",float:"left",zIndex:"1"}}>
                          <div class="card-body">
                            <h5 class="card-title" style={{fontSize:"14px",color:"green"}}>Select Shop</h5>
                            {updateformData.shops.map((shop, index) => (
        <div className="form-check" key={index}>
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id={`flexCheckDefaultupdate_${index}`}
            onChange={() => handleUpdateCheckboxChange(index)}
            checked={shop.is_active === 1}
          />
          <label className="form-check-label" htmlFor={`flexCheckDefaultupdate_${index}`}>{shop.shop_name}</label>
        </div>
      ))}   
                           
                          </div>
                         </div>
       </div>
       <div class="col">
       </div> 
       </div> */}
         <br/>
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"15px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"15px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Blocked Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={Submit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Select Date</label>
               <input type="date" class="form-control" id="floatingInput" placeholder="Select Date" name='Enter date' value={formData.e_name} onChange={handleInputChange}  style={{borderRadius:"15px",height:"50px"}} required/>
               </div>
               <div className="col">
  <label
    htmlFor="slotSelect"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
    Select Slot
  </label>
  <select
    className="form-control"
    id="slotSelect"
    name="e_slot"
    value={updateformData.e_slot}
    onChange={handleInputChange}
    style={{ borderRadius: "12px" }}
    required
  >
    <option value="">Select a Slot</option>
    <option value="slot1">Slot 1</option>
    <option value="slot2">Slot 2</option>
    <option value="slot3">Slot 3</option>
    {/* Add more options as needed */}
  </select>
</div>

          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Enter Remarks{" "}</label>
            <input type="text" class="form-control" id="formFile" placeholder='Enter Remarks' onChange={handleImageChange} name='profile'  style={{borderRadius:"15px",height:"50px"}} />
            </div>
          </div>
          {/* <div class="row">
            <div class="col">
            <div class="card mb-3" style={{width: "22rem",margin:"auto",height:"10rem",borderRadius:"15px",border:"none",overflowX:"scroll",zIndex:"1"}}>
                          <div class="card-body">
                            <h5 class="card-title" style={{fontSize:"14px",color:"green"}}>Select Shop</h5>
                            {formData.shops.map((shop, index) => (
        <div className="form-check" key={index}>
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id={`flexCheckDefault_${index}`}
            onChange={() => handleCheckboxChange(index)}
            checked={shop.is_active === 1}
          />
          <label className="form-check-label" htmlFor={`flexCheckDefault_${index}`}>{shop.shop_name}</label>
        </div>
      ))}   
                           
                          </div>
                         </div>
                         </div>
       <div class="col">
       </div> 
       </div> */}
         <br/>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} disabled={postloading}>Create</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>setCreate(false)} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={refundpopup}
        onHide={()=>setrefundpopup(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Apply Refund</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={Submit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Refund Date</label>
               <input type="date" class="form-control" id="floatingInput" placeholder="Select Date" name='Enter date' value={formData.e_name} onChange={handleInputChange}  style={{borderRadius:"15px",height:"50px"}} required/>
               </div>
          </div>
          <br/>
          <div class="row">
          <div className="col">
  <label
    htmlFor="slotSelect"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
    Method
  </label>
  <select
    className="form-control"
    id="slotSelect"
    name="e_slot"
    value={updateformData.e_slot}
    onChange={handleInputChange}
    style={{ borderRadius: "12px" }}
    required
  >
    <option value="">Select</option>
    <option value="slot1">Credit</option>
    <option value="slot2">Debit</option>
    <option value="slot3">Net Banking</option>
    {/* Add more options as needed */}
  </select>
</div>
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Amount{" "}</label>
            <input type="number" class="form-control" id="formFile" placeholder='Enter Amount' onChange={handleImageChange} name='profile'  style={{borderRadius:"15px",height:"50px"}} />
            </div>
          </div>
          <div class="row">
          <div className="col">
      <label htmlFor="description" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
        Refund Notes
      </label>
      <textarea
        id="description"
        className="form-control"
        value={remarks}
        onChange={setRemarks}
        placeholder="Enter a description..."
        rows="4"
        style={{ borderRadius: "15px", height: "100px", resize: "vertical" }} // Matches other input styles
        required
      />
    </div>
       </div>
         <br/>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} disabled={postloading}>Apply</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>setrefundpopup(false)} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 


            {/* </div> */}
       </Layout></>

        
    )
}

export default RefundList;